const enterpriseInfoIndex = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/enterpriseInfoIndex.vue')), 'enterpriseInfoIndex');
const enterpriseDetail = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/enterpriseDetail.vue')), 'enterpriseDetail');
const projectMgeList = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/projectMgeList.vue')), 'projectMgeList');
const applyList = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/applyList.vue')), 'applyList');
const addProject = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/addProject.vue')), 'addProject');
const projectDetail = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/projectDetail.vue')), 'projectDetail');
const editProject = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/editProject.vue')), 'editProject');
const editApplyProject = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/editApplyProject.vue')), 'editApplyProject');
const applyProjectDetail = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/applyProjectDetail.vue')), 'applyProjectDetail');
const enterpriseBasicAllInfo = r => require.ensure([], () => r(require('@/page/enterpriseInfoMge/components/enterpriseBasicAllInfo.vue')), 'enterpriseBasicAllInfo');
const enterpriseProjectRouter = {
    path: '',
    name: '企业信息管理',
    component: enterpriseInfoIndex,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive: true,
    },
    children: [
        {
          path: '/enterpriseDetail',
          component: enterpriseDetail,
          name: '物业企业详情',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/projectMgeList',
          component: projectMgeList,
          name: '深圳市项目管理',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/applyList',
          component: applyList,
          name: '查看申请记录',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/projectInfoDetail',
          component: projectDetail ,
          name: '项目信息',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/addProjectInfo',
          component: addProject ,
          name: '新增物业项目',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/editProjectInfo',
          component: editProject ,
          name: '编辑物业项目',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/editApplyProject',
          component: editApplyProject ,
          name: '编辑物业项目',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/applyProjectDetail',
          component: applyProjectDetail ,
          name: '项目详情',
          meta: {
            right: [],
            isShowMenu: true,
          },
        },
        {
          path: '/enterpriseBasicAllInfo ',
          component: enterpriseBasicAllInfo ,
          name: '基本信息',
          meta: {
            right: [],
            isShowMenu: true,
          },
        }
    ]
};
export default enterpriseProjectRouter;